export default `
query QueryServiceProviderUsers(
  $serviceProviderId: ID!, 
  $from: Float,
  $to: Float,
  $after: String
) {
  queryServiceProviderUsersByServiceProviderIdUpdatedAtIndex(
    serviceProviderId: $serviceProviderId, 
    from: $from,
    to: $to,
    after: $after
  ) {
    items {
      coordinates {
        lat
        lng
      }
      officerLevel
      userId
      updatedAt
      displayName
      serviceProviderId
      status
      role
      respondingTo {
        instanceId
        propertyId
      }
      isDeleted
      inRange
    }
  }
}
`;